/**
 * A FORMA EM QUE O PAINEL DE DETALHE ABRE, lembrada por pessoa e por tela
 * (pedido do dono, 31/10/2026).
 *
 * O painel abre EXPANDIDO, na janela larga. Quem prefere a coluna estreita ao
 * lado da lista reduz uma vez, e a escolha fica: da próxima vez que abrir uma
 * linha NAQUELA tela, ele já vem reduzido. Uma chave por pessoa e por tela,
 * porque a escolha de quem confere abastecimentos linha a linha não é a de
 * quem edita a ficha da máquina.
 *
 * Mora no `localStorage` deste navegador, e só. Não é dado do sistema: é
 * preferência de leitura. Todo acesso passa por `try/catch`, como o rascunho
 * (`modulos/operacao/rascunho.ts`): com o armazenamento bloqueado, o navegador
 * LEVANTA em vez de devolver nulo, e uma preferência não pode derrubar a tela.
 */

export type FormaDoPainel = 'expandido' | 'reduzido';

/** O que o painel usa do armazenamento: injetado, para o teste não pedir navegador. */
export interface ArmazemDaForma {
  getItem(chave: string): string | null;
  setItem(chave: string, valor: string): void;
}

const PREFIXO = 'ct-frotas:painel:';

/**
 * A chave de uma pessoa numa tela. Sem sessão conhecida (o espelho ainda não
 * chegou), a escolha vale para "sem sessão" e não se mistura com a de ninguém.
 */
export function chaveDaForma(pessoa: string | null | undefined, tela: string): string {
  return `${PREFIXO}${pessoa && pessoa.trim() !== '' ? pessoa : 'sem-sessao'}:${telaDoEndereco(tela)}`;
}

/** A tela pelo endereço: sem a barra do fim, para `/frota/` e `/frota` serem a mesma. */
export function telaDoEndereco(caminho: string): string {
  const limpo = caminho.split(/[?#]/)[0]?.replace(/\/+$/, '') ?? '';
  return limpo === '' ? '/' : limpo;
}

/** A forma guardada, ou o padrão da tela quando não há escolha (ou ela não se lê). */
export function lerForma(armazem: ArmazemDaForma | null, chave: string, padrao: FormaDoPainel): FormaDoPainel {
  try {
    const guardada = armazem?.getItem(chave) ?? null;
    return guardada === 'expandido' || guardada === 'reduzido' ? guardada : padrao;
  } catch {
    return padrao;
  }
}

export function gravarForma(armazem: ArmazemDaForma | null, chave: string, forma: FormaDoPainel): void {
  try {
    armazem?.setItem(chave, forma);
  } catch {
    // Armazenamento bloqueado: o painel continua, só sem lembrar a escolha.
  }
}

/** O `localStorage`, quando o navegador deixa ler (no modo privado do Safari antigo, nem isso). */
export function armazemDoNavegador(): ArmazemDaForma | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}
